import { Model } from 'infra/model'
import { observable, makeObservable } from 'mobx'

import { ProOpenJobCountDTO } from './dtos'

export class ProOpenJobCount extends Model<
  ProOpenJobCountDTO,
  ProOpenJobCount
> {
  @observable workspaceId = ''
  @observable total = 0

  constructor() {
    super()

    makeObservable(this)
  }

  parse(attrs: Partial<ProOpenJobCountDTO>) {
    return {
      workspaceId: attrs.workspaceId,
      total: attrs.total,
    }
  }
}
